module.exports = __webpack_public_path__ + "img/Dantam Bridal 04.f679fa8d.jpg";